import { Box } from '@interstate/components/Box';
import { SlideOut } from '@interstate/components/SlideOut';

import { useGetDrawerWidth } from '../../dealActivity/activities/hooks/useGetDrawerWidth';
import { ManualTemplateList } from './ManualTemplateList';

export const ManualTemplatesListSlideOut = ({ isOpen, onHide }: { isOpen: boolean; onHide: () => void }) => {
    const panelWidth = useGetDrawerWidth();

    return (
        <SlideOut
            data-testid="manual-template-list-drawer"
            header="Apply Templates"
            show={isOpen}
            position="right"
            panelWidth={panelWidth}
            onHide={onHide}
        >
            <Box data-testid="manual-template-list-wrapper">
                <ManualTemplateList hide={onHide} />
            </Box>
        </SlideOut>
    );
};
